import taxGroupHeadingServiceGen from "./generated/taxGroupHeadingServiceGen";

class taxGroupHeadingService extends taxGroupHeadingServiceGen {
}

export default taxGroupHeadingService;